import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import AntGrid from './AntGrid';

export default forwardRef(function (props, ref) {
    const grid = useRef();

    const reload = useCallback((opts) => {
        if (grid.current) {
            grid.current.forceReload(opts);
        }
    }, []);

    const refresh = useCallback(() => {
        if (grid.current) {
            grid.current.refresh();
        }
    }, []);

    const getSelectedRows = useCallback(() => {
        if (grid.current) return grid.current.getSelectedRows();
        return [];
    }, []);

    const getSelectedObjectId = useCallback(() => {
        if (grid.current) return grid.current.getSelectedObjectId();
        return null;
    }, []);

    useImperativeHandle(ref, () => ({
        refresh: refresh,
        reload: reload,
        getSelectedRows: getSelectedRows,
        getSelectedObjectId: getSelectedObjectId
    }));

    const storageKey = props.storageKey
        ? props.storageKey
        : 'searching-grid-' +
          (props.name ? props.name : props.entityName ? props.entityName : props.API && props.API.entityName ? props.API.entityName : '');

    return (
        <React.Fragment>
            <AntGrid
                ref={grid}
                API={props.API}
                url={props.url}
                table={props.table}
                isSearching={true}
                searchConditions={props.searchConditions}
                searchFields={props.searchFields}
                selectFields={props.selectFields}
                queryFields={props.queryFields}
                entityName={props.entityName}
                entityDisplay={props.entityDisplay}
                storageKey={props.storageKey ? props.storageKey : storageKey}
                settingsKey={props.settingsKey || props.storageKey}
                showRowActions={props.showRowActions}
                rowActionPack={props.rowActionPack}
                rowActions={props.rowActions}
                excludesRowActions={props.excludesRowActions}
                rowActionWidth={props.rowActionWidth}
                rowActionsDisplay={props.rowActionsDisplay}
                rowActionPrimaryActions={props.rowActionPrimaryActions}
                batchActions={props.batchActions}
                autoBatchActions={props.autoBatchActions}
                onBatchExecuted={props.onBatchExecuted}
                rowAlternationEnabled={props.rowAlternationEnabled}
                hoverStateEnabled={props.hoverStateEnabled}
                onRowAction={props.onRowAction}
                rowStyles={props.rowStyles}
                cellStyles={props.cellStyles}
                cellRenders={props.cellRenders}
                cellContext={props.cellContext}
                onLoaded={props.onLoaded}
                orderBy={props.orderBy}
                orderType={props.orderType}
                showIndex={props.showIndex}
                showDetail={props.showDetail}
                showNote={props.showNote}
                showAttachments={props.showAttachments}
                showPriority={props.showPriority}
                priorityField={props.priorityField}
                keyExpr={props.keyExpr}
                loadFunc={props.loadFunc}
                remotePaging={props.remotePaging}
                updateMode={props.updateMode}
                sortable={props.sortable}
                focusable={props.focusable}
                focusedRowEnabled={props.focusedRowEnabled}
                selectable={props.selectable}
                selectionMode={props.selectionMode}
                defaultPageSize={props.defaultPageSize}
                allowedPageSizes={props.allowedPageSizes}
                columns={props.columns}
                fields={props.fields}
                actionItems={props.actionItems}
                scheduler={props.scheduler}
                cardview={props.cardview}
                defaultView={props.defaultView}
                onFilteredByGroupChanged={props.onFilteredByGroupChanged}
                searchText={props.searchText}
                onSearchText={props.onSearchText}
                isAllowQuery={props.isAllowQuery}
                showActionBar={props.showActionBar}
                showRefresh={props.showRefresh ? props.showRefresh : true}
                showAdd={props.showAdd}
                canEditAction={props.canEditAction}
                canDeleteAction={props.canDeleteAction}
                showImport={props.showImport}
                add={props.add}
                import={props.import}
                showDownload={props.showDownload}
                showSearchBar={props.showSearchBar}
                autoFocusSearchBar={props.autoFocusSearchBar}
                showFieldChooser={props.showFieldChooser}
                locationRefresh={props.locationRefresh}
                locationAdd={props.locationAdd}
                locationImport={props.locationImport}
                locationDownload={props.locationDownload}
                onImport={props.onImport}
                onAdd={props.onAdd}
                pagerHideable={props.pagerHideable}
                showPageSizeSelector={props.showPageSizeSelector}
                hideHeaderMargin={props.hideHeaderMargin}
                height={props.height}
                // showDetailPosition={'right'}

                searchCategories1={props.searchCategories1}
                categoriesQueryEnabled={props.categoriesQueryEnabled}
                searchCategories2={props.searchCategories2}
                searchCategories3={props.searchCategories3}
                searchCategories4={props.searchCategories4}
                searchCategories5={props.searchCategories5}
                searchCategories6={props.searchCategories6}
                searchCategories7={props.searchCategories7}
                searchCategories8={props.searchCategories8}
                searchCategories9={props.searchCategories9}
                searchCategories10={props.searchCategories10}
                summaryHeader={props.summaryHeader}
                dateFilterField={props.dateFilterField}
                showDateFilter={props.showDateFilter}
            />
        </React.Fragment>
    );
});
